module.exports = __webpack_public_path__ + "img/48600.a391e88b.jpg";